(function () {
  'use strict';

  var SCENT_FAMILIES = [
    { key: 'floral', label: 'Floral', match: /\b(rose|jasmine|lavender|peony|orchid|gardenia|lily|magnolia|tuberose|violet|petal|blossom)\b/i },
    { key: 'citrus', label: 'Citrus', match: /\b(lemon|lime|orange|bergamot|grapefruit|mandarin|citrus|yuzu|tangerine|lemongrass)\b/i },
    { key: 'fresh', label: 'Fresh', match: /\b(cotton|linen|ocean|sea breeze|mint|eucalyptus|aqua|aquatic|cucumber|aloe|crisp|breeze)\b/i },
    { key: 'woody', label: 'Woody', match: /\b(sandalwood|cedar|oud|vetiver|patchouli|teakwood|mahogany|tobacco|leather|amber|pine|musk|sage|woody)\b/i },
    { key: 'fruity', label: 'Fruity', match: /\b(apple|peach|berry|cherry|pineapple|mango|raspberry|strawberry|fig|plum|melon|coconut|pear|cassis)\b/i },
    { key: 'sweet', label: 'Sweet', match: /\b(vanilla|caramel|honey|chocolate|cream|praline|tonka|cocoa|toffee|gourmand|marshmallow|maple)\b/i },
    { key: 'spicy', label: 'Spicy', match: /\b(cinnamon|clove|cardamom|pepper|ginger|saffron|spice|nutmeg|peppercorn)\b/i }
  ];

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function money(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD', minimumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  }

  function track(eventName, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, detail || {}));
  }

  function init(root) {
    var dataNode = document.getElementById('ap-membership-data');
    var payload;
    try {
      payload = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error('[scent-membership] data parse failed', error);
      return;
    }

    var products = Array.isArray(payload.products) ? payload.products : [];
    var state = {
      size: '30',
      frequency: 'biweekly',
      bottleCount: 3,
      selected: [],
      filterType: 'category',
      filterKey: 'all',
      query: '',
      showAll: false,
      step: 1,
      submitting: false
    };

    var builder = root.querySelector('[data-apsm-builder]');
    var grid = builder.querySelector('[data-apsm-products]');
    var categoryFilters = builder.querySelector('[data-apsm-category-filters]');
    var scentFilters = builder.querySelector('[data-apsm-scent-filters]');
    var packs = builder.querySelector('[data-apsm-packs]');
    var railList = builder.querySelector('[data-apsm-rail-list]');
    var peek = builder.querySelector('[data-apsm-peek]');
    var peekBody = builder.querySelector('[data-apsm-peek-body]');
    var reviewList = builder.querySelector('[data-apsm-review-list]');
    var searchInput = builder.querySelector('[data-apsm-search]');
    var results = builder.querySelector('[data-apsm-results]');
    var foot = builder.querySelector('.os-foot');

    function variantFor(product) {
      return product && product.variants ? product.variants[state.size] : null;
    }

    function planFor(variant) {
      return variant && variant.plans ? variant.plans[state.frequency] : null;
    }

    function planForFrequency(variant, frequency) {
      return variant && variant.plans ? variant.plans[frequency] : null;
    }

    function planDiscount() {
      return state.frequency === 'biweekly' ? 20 : 15;
    }

    function frequencyLabel() {
      return state.frequency === 'biweekly' ? 'every 2 weeks' : 'every month';
    }

    function productById(id) {
      return products.find(function (product) { return String(product.id) === String(id); });
    }

    function selectedProducts() {
      return state.selected.map(productById).filter(Boolean);
    }

    function productFamilies(product) {
      var text = [product.title, product.notes].join(' ');
      return SCENT_FAMILIES.filter(function (family) { return family.match.test(text); })
        .map(function (family) { return family.key; });
    }

    function availableProducts() {
      return products.filter(function (product) {
        var variant = variantFor(product);
        return variant && variant.available && planFor(variant);
      });
    }

    function totals() {
      return selectedProducts().reduce(function (sum, product) {
        var variant = variantFor(product);
        var plan = planFor(variant);
        sum.regular += variant.price;
        sum.member += plan.memberPrice;
        return sum;
      }, { regular: 0, member: 0 });
    }

    function configurationTotals(frequency) {
      var product = products.find(function (item) {
        var variant = item.variants ? item.variants[state.size] : null;
        return variant && variant.available && planForFrequency(variant, frequency);
      });
      if (!product) return { regular: 0, member: 0, unitRegular: 0 };
      var variant = product.variants[state.size];
      var plan = planForFrequency(variant, frequency);
      return {
        regular: variant.price * state.bottleCount,
        member: plan.memberPrice * state.bottleCount,
        unitRegular: variant.price
      };
    }

    function renderSizeOptions() {
      builder.querySelectorAll('[data-apsm-sizes] [data-size]').forEach(function (button) {
        var size = button.dataset.size;
        var product = products.find(function (item) {
          var variant = item.variants ? item.variants[size] : null;
          return variant && variant.available && planForFrequency(variant, state.frequency);
        });
        var priceNode = button.querySelector('[data-apsm-size-price]');
        var perMlNode = button.querySelector('[data-apsm-size-perml]');
        if (!product) {
          priceNode.textContent = 'Unavailable';
          perMlNode.textContent = '';
          button.disabled = true;
          return;
        }
        var variant = product.variants[size];
        var plan = planForFrequency(variant, state.frequency);
        button.disabled = false;
        priceNode.textContent = money(plan.memberPrice) + ' / delivery';
        priceNode.dataset.mobilePrice = money(plan.memberPrice);
        perMlNode.textContent = '$' + ((plan.memberPrice / 100) / Number(size)).toFixed(2) + '/ml · ' + plan.discount + '% off';
        perMlNode.dataset.mobilePerMl = '$' + ((plan.memberPrice / 100) / Number(size)).toFixed(2) + '/ml';
      });
    }

    function remaining() {
      return Math.max(0, state.bottleCount - state.selected.length);
    }

    function progressSegments(className) {
      var html = '';
      for (var index = 0; index < state.bottleCount; index += 1) {
        html += '<span class="' + className + (index < state.selected.length ? ' is-on' : '') + '"></span>';
      }
      return html;
    }

    function filterProducts() {
      return availableProducts().filter(function (product) {
        var matchesFilter = state.filterType === 'category'
          ? state.filterKey === 'all' || product.category === state.filterKey
          : productFamilies(product).indexOf(state.filterKey) !== -1;
        var haystack = (product.title + ' ' + product.notes).toLowerCase();
        return matchesFilter && (!state.query || haystack.indexOf(state.query) !== -1);
      });
    }

    function renderFilters() {
      var available = availableProducts();
      var categories = [
        { key: 'all', label: 'All' }, { key: 'hotel', label: 'Hotel' },
        { key: 'perfume', label: 'Perfume' }, { key: 'nature', label: 'Nature' }
      ];
      categoryFilters.innerHTML = '<span class="os-chips-label">Type</span>' + categories.map(function (category) {
        var count = category.key === 'all' ? available.length : available.filter(function (product) { return product.category === category.key; }).length;
        if (!count && category.key !== 'all') return '';
        var active = state.filterType === 'category' && state.filterKey === category.key;
        return '<button class="os-chip' + (active ? ' is-on' : '') + '" type="button" data-filter-category="' + category.key + '">' + category.label + '<span class="os-chip__n">' + count + '</span></button>';
      }).join('');

      scentFilters.innerHTML = '<span class="os-chips-label">Scent</span>' + SCENT_FAMILIES.map(function (family) {
        var count = available.filter(function (product) { return productFamilies(product).indexOf(family.key) !== -1; }).length;
        if (!count) return '';
        var active = state.filterType === 'scent' && state.filterKey === family.key;
        return '<button class="os-chip os-chip--scent' + (active ? ' is-on' : '') + '" type="button" data-filter-scent="' + family.key + '">' + family.label + '<span class="os-chip__n">' + count + '</span></button>';
      }).join('');
    }

    function renderPacks() {
      var definitions = [
        { key: 'hotel', name: 'Hotel Favorites', sub: 'Lobby-inspired scents' },
        { key: 'perfume', name: 'Perfume Icons', sub: 'Fine-fragrance inspired' },
        { key: 'nature', name: 'Nature Reset', sub: 'Fresh, grounding scents' }
      ];
      packs.innerHTML = definitions.map(function (definition) {
        var picks = availableProducts().filter(function (product) { return product.category === definition.key; }).slice(0, Math.max(3, state.bottleCount));
        if (!picks.length) return '';
        return '<button class="os-pack" type="button" data-pack="' + definition.key + '">' +
          '<span class="os-pack__name">' + definition.name + '</span>' +
          '<span class="os-pack__strip">' + picks.slice(0, 3).map(function (product) { return '<img src="' + escapeHtml(product.image) + '" alt="" width="36" height="36" loading="lazy">'; }).join('') + '</span>' +
          '<span class="os-pack__sub">Fill all ' + state.bottleCount + ' spots · ' + definition.sub + '</span></button>';
      }).join('');
    }

    function renderCards() {
      var list = filterProducts();
      list.sort(function (a, b) {
        var aIndex = state.selected.indexOf(String(a.id));
        var bIndex = state.selected.indexOf(String(b.id));
        if (aIndex === -1 && bIndex === -1) return 0;
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
      });
      if (!list.length) {
        grid.innerHTML = '<div class="os-empty"><div class="os-empty__icon">⌖</div><h3 class="os-empty__h">No matches</h3><p class="os-empty__sub">Try another category or scent family for this bottle size.</p><button class="os-empty__reset" type="button" data-reset-filter>See all scents</button></div>';
        results.innerHTML = '<span>No matching scents</span>';
        return;
      }
      var limitList = state.filterType === 'category' && state.filterKey === 'all' && !state.query && !state.showAll ? list.slice(0, 18) : list;
      grid.innerHTML = limitList.map(function (product) {
        var variant = variantFor(product);
        var plan = planFor(variant);
        var quantity = state.selected.filter(function (id) { return id === String(product.id); }).length;
        var picked = quantity > 0;
        var rating = Number(product.rating || 0);
        var reviewCount = Number(product.reviewCount || 0);
        var ratingHtml = rating > 0 && reviewCount > 0
          ? '<div class="os-card__rating" aria-label="Rated ' + rating.toFixed(1) + ' out of 5">' +
              '<span class="os-card__stars" style="--pct:' + (rating / 5 * 100).toFixed(0) + '%">★★★★★</span>' +
              '<span class="os-card__rnum">' + rating.toFixed(1) + '</span>' +
              '<span class="os-card__rcnt">(' + reviewCount + ')</span></div>'
          : '';
        return '<article class="os-card' + (picked ? ' is-picked' : '') + '" data-product-id="' + escapeHtml(product.id) + '" data-picked-label="ADDED' + (quantity > 1 ? ' × ' + quantity : '') + '" tabindex="0" role="button" aria-pressed="' + (picked ? 'true' : 'false') + '">' +
          '<div class="os-card__check"></div><div class="os-card__img"><div class="os-card__cat os-card__cat--' + escapeHtml(product.category) + '">' + escapeHtml(product.category) + '</div>' +
          '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + ' waterless fragrance oil" width="300" height="300" loading="lazy"></div>' +
          '<div class="os-card__body"><h3 class="os-card__title">' + escapeHtml(product.title) + '</h3>' +
          '<p class="os-card__notes">' + escapeHtml(product.notes || 'Waterless home fragrance oil') + '</p>' +
          '<div class="os-card__price">' + money(plan.memberPrice) + '<small>/' + state.size + ' ml bottle, per delivery</small></div>' +
          '<div class="apsm-card-saving"><s>' + money(variant.price) + '</s> ' + plan.discount + '% off</div>' +
          ratingHtml + '</div></article>';
      }).join('');
      results.innerHTML = limitList.length < list.length
        ? '<span>Showing ' + limitList.length + ' of ' + list.length + ' scents</span><button type="button" data-apsm-show-all>Show all ' + list.length + ' scents</button>'
        : '<span>Showing ' + list.length + (state.query ? ' matching' : '') + ' scents</span>';
    }

    function summaryRow(product, mobile) {
      var variant = variantFor(product);
      var plan = planFor(variant);
      if (mobile) {
        return '<div class="os-peek__row"><div class="os-peek__thumb"><img src="' + escapeHtml(product.image) + '" alt=""></div><span class="os-peek__name">' + escapeHtml(product.title) + '</span><button class="os-peek__remove" type="button" data-remove-id="' + escapeHtml(product.id) + '" aria-label="Remove ' + escapeHtml(product.title) + '">×</button></div>';
      }
      return '<div class="os-rail__item"><div class="os-rail__thumb"><img src="' + escapeHtml(product.image) + '" alt=""></div><span class="os-rail__name">' + escapeHtml(product.title) + '</span><span class="apsm-rail-price">' + money(plan.memberPrice) + '</span><button class="os-rail__remove" type="button" data-remove-id="' + escapeHtml(product.id) + '" aria-label="Remove ' + escapeHtml(product.title) + '">×</button></div>';
    }

    function renderSummary() {
      var selected = selectedProducts();
      var sum = totals();
      var missing = remaining();
      var emptyRail = '';
      var emptyPeek = '';
      for (var index = 0; index < missing; index += 1) {
        emptyRail += '<div class="os-rail__item os-rail__item--empty">Pick scent ' + (selected.length + index + 1) + '</div>';
        emptyPeek += '<div class="os-peek__row os-peek__row--empty">Pick scent ' + (selected.length + index + 1) + '</div>';
      }
      railList.innerHTML = selected.map(function (product) { return summaryRow(product, false); }).join('') + emptyRail;
      peekBody.innerHTML = selected.map(function (product) { return summaryRow(product, true); }).join('') + emptyPeek;

      builder.querySelector('[data-apsm-rail-count]').textContent = selected.length;
      builder.querySelector('[data-apsm-rail-required]').textContent = state.bottleCount;
      builder.querySelector('[data-apsm-rail-regular]').textContent = money(sum.regular);
      builder.querySelector('[data-apsm-rail-savings]').textContent = '−' + money(sum.regular - sum.member);
      builder.querySelector('[data-apsm-rail-savings-label]').textContent = 'Your ' + planDiscount() + '% savings';
      builder.querySelector('[data-apsm-rail-total]').textContent = money(sum.member);
      builder.querySelector('[data-apsm-peek-count]').textContent = selected.length + '/' + state.bottleCount;
      builder.querySelector('[data-apsm-peek-label]').textContent = 'scents · ' + money(sum.member) + ' first order';
      builder.querySelector('[data-apsm-builder-sub]').innerHTML = state.bottleCount + ' bottles ' + frequencyLabel() + ' · <span class="os-save">Save ' + planDiscount() + '%</span> · swap future scents online';
      builder.querySelector('[data-apsm-progress-label]').textContent = selected.length + ' of ' + state.bottleCount + ' scents';
      builder.querySelector('[data-apsm-monthly]').textContent = money(sum.member) + '/order';
      builder.querySelector('[data-apsm-progress]').innerHTML = progressSegments('os-tiers__seg');
      builder.querySelector('[data-apsm-foot-progress]').innerHTML = progressSegments('os-foot__seg');
      builder.querySelector('[data-apsm-foot-count]').textContent = selected.length;
      builder.querySelector('[data-apsm-foot-message]').textContent = 'of ' + state.bottleCount + ' selected';
      builder.querySelector('[data-apsm-foot-picks]').innerHTML = selected.map(function (product) { return '<span class="os-foot__pick"><img src="' + escapeHtml(product.image) + '" alt=""></span>'; }).join('');

      var shippingStatuses = builder.querySelectorAll('[data-apsm-shipping-status]');
      var shippingMessages = builder.querySelectorAll('[data-apsm-shipping-message]');
      var shippingMeters = builder.querySelectorAll('[data-apsm-shipping-meter]');
      var shippingOrderValue = configurationTotals(state.frequency).member;
      var shippingRemaining = Math.max(0, 4999 - shippingOrderValue);
      var shippingQualified = shippingRemaining === 0;
      shippingStatuses.forEach(function (status) {
        status.classList.toggle('is-qualified', shippingQualified);
      });
      var shippingMessage = shippingQualified
        ? '<b>Free shipping unlocked</b> for each qualifying membership order.'
        : '<b>Add ' + money(shippingRemaining) + ' per order</b> to unlock free shipping.';
      shippingMessages.forEach(function (message) {
        message.innerHTML = shippingMessage;
      });
      shippingMeters.forEach(function (meter) {
        var shippingValue = Math.min(shippingOrderValue, 4999);
        meter.setAttribute('aria-valuenow', shippingValue);
        meter.style.setProperty('--apsm-shipping-progress', ((shippingValue / 4999) * 100).toFixed(2) + '%');
      });
      var reviewShipping = builder.querySelector('[data-apsm-review-shipping]');
      reviewShipping.classList.toggle('is-qualified', shippingQualified);
      builder.querySelector('[data-apsm-review-shipping-value]').textContent = shippingQualified ? 'FREE' : 'Calculated at checkout';

      ['monthly', 'biweekly'].forEach(function (frequency) {
        var estimate = configurationTotals(frequency);
        var totalNode = builder.querySelector('[data-apsm-frequency-total="' + frequency + '"]');
        if (totalNode) totalNode.textContent = money(estimate.member);
      });

      var configured = configurationTotals(state.frequency);
      root.querySelector('[data-apsm-savings-regular]').textContent = money(configured.regular);
      root.querySelector('[data-apsm-savings-amount]').textContent = '−' + money(configured.regular - configured.member);
      root.querySelector('[data-apsm-savings-total]').textContent = money(configured.member);
      root.querySelector('[data-apsm-savings-percent]').textContent = planDiscount() + '%';
      root.querySelector('[data-apsm-savings-monthly]').textContent = money(configured.member);
      root.querySelector('[data-apsm-savings-config]').textContent = state.bottleCount + ' × ' + state.size + ' ml · delivered ' + frequencyLabel() + ' · no discount code needed';

      var message = missing ? 'Pick ' + missing + ' to continue →' : 'Review membership →';
      var reviewCta = builder.querySelector('[data-apsm-review-cta]');
      var peekCta = builder.querySelector('[data-apsm-peek-cta]');
      reviewCta.textContent = message;
      peekCta.textContent = message;
      reviewCta.disabled = missing !== 0;
      peekCta.disabled = missing !== 0;
      builder.querySelector('[data-apsm-next]').disabled = missing !== 0;

      var nudge = builder.querySelector('[data-apsm-nudge]');
      nudge.classList.add('is-on');
      nudge.classList.toggle('is-complete', missing === 0);
      builder.querySelector('[data-apsm-nudge-message]').innerHTML = selected.length === 0
        ? 'Choose <b>' + missing + ' scents</b> for your first delivery.'
        : missing
          ? 'Choose <b>' + missing + ' more scent' + (missing === 1 ? '' : 's') + '</b> for your delivery.'
          : '<b>First delivery complete.</b> Review membership.';
    }

    function renderReview() {
      var selected = selectedProducts();
      var sum = totals();
      reviewList.innerHTML = selected.map(function (product, index) {
        var variant = variantFor(product);
        var plan = planFor(variant);
        return '<li class="os-review__item"><span class="os-review__num">' + (index + 1) + '</span><span class="os-review__thumb"><img src="' + escapeHtml(product.image) + '" alt=""></span><span><span class="os-review__title">' + escapeHtml(product.title) + '</span><span class="os-review__meta">' + state.size + ' ml · delivered ' + frequencyLabel() + '</span></span><span class="os-review__price">' + money(plan.memberPrice) + '/order</span></li>';
      }).join('');
      builder.querySelector('[data-apsm-review-sub]').textContent = state.bottleCount + ' × ' + state.size + ' ml · delivered ' + frequencyLabel();
      builder.querySelector('[data-apsm-review-regular]').textContent = money(sum.regular);
      builder.querySelector('[data-apsm-review-savings]').textContent = '−' + money(sum.regular - sum.member);
      builder.querySelector('[data-apsm-review-savings-label]').textContent = 'Your ' + planDiscount() + '% savings';
      builder.querySelector('[data-apsm-review-shipping-label]').textContent = 'Shipping for this order';
      builder.querySelector('[data-apsm-review-total-label]').textContent = 'First order';
      builder.querySelector('[data-apsm-review-total]').textContent = money(sum.member);
      builder.querySelector('[data-apsm-review-note]').innerHTML = '<strong>' + money(sum.member) + ' charged for the first order.</strong> Future orders recur ' + frequencyLabel() + ' until canceled. Shipping and taxes, if applicable, are calculated at checkout. Use Bottle Swap to change future scents.';
    }

    function render() {
      state.selected = state.selected.filter(function (id) {
        var variant = variantFor(productById(id));
        return variant && variant.available && planFor(variant);
      }).slice(0, state.bottleCount);
      builder.querySelector('[data-apsm-count]').textContent = state.bottleCount;
      renderSizeOptions();
      renderFilters();
      renderPacks();
      renderCards();
      renderSummary();
      renderReview();
    }

    function addProduct(id) {
      id = String(id);
      if (state.selected.length < state.bottleCount) {
        state.selected.push(id);
        track('scent_membership_scent_added', { product_id: id, size_ml: state.size });
      } else {
        grid.classList.remove('is-shake');
        void grid.offsetWidth;
        grid.classList.add('is-shake');
        return;
      }
      render();
    }

    function removeProduct(id) {
      var selectedIndex = state.selected.lastIndexOf(String(id));
      if (selectedIndex !== -1) state.selected.splice(selectedIndex, 1);
      render();
    }

    function toggleProduct(id) {
      id = String(id);
      if (state.selected.indexOf(id) !== -1) {
        state.selected = state.selected.filter(function (selectedId) { return selectedId !== id; });
        render();
        return;
      }
      addProduct(id);
    }

    function goStep(step) {
      if (step === 2 && remaining()) return;
      state.step = step;
      builder.querySelectorAll('[data-apsm-pane]').forEach(function (pane) { pane.classList.toggle('is-active', Number(pane.dataset.apsmPane) === step); });
      builder.querySelectorAll('[data-apsm-step]').forEach(function (item) {
        var itemStep = Number(item.dataset.apsmStep);
        item.classList.toggle('is-current', itemStep === step);
        item.classList.toggle('is-done', itemStep < step);
      });
      builder.querySelector('[data-apsm-back]').style.display = step === 2 ? '' : 'none';
      var next = builder.querySelector('[data-apsm-next]');
      next.textContent = step === 2 ? 'Checkout →' : 'Continue →';
      next.classList.toggle('os-btn--gold', step === 2);
      next.classList.toggle('os-btn--ink', step !== 2);
      peek.classList.remove('is-open');
      peek.style.display = step === 1 ? '' : 'none';
      builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (step === 2) track('scent_membership_review_opened', { bottle_count: state.bottleCount, size_ml: state.size });
      updateFootVisibility();
    }

    function updateFootVisibility() {
      var rect = builder.getBoundingClientRect();
      var inBuilder = rect.top < window.innerHeight - 80 && rect.bottom > 100;
      foot.classList.toggle('is-in-builder', state.step === 2 && inBuilder);
      peek.classList.toggle('is-in-builder', state.step === 1 && inBuilder);
    }

    root.querySelectorAll('a[href="#build-membership"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        builder.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    async function submit() {
      if (state.submitting || remaining()) return;
      state.submitting = true;
      var button = builder.querySelector('[data-apsm-next]');
      button.disabled = true;
      button.textContent = 'Preparing checkout…';
      var items = selectedProducts().map(function (product) {
        var variant = variantFor(product);
        var plan = planFor(variant);
        return {
          id: Number(variant.id), quantity: 1, selling_plan: Number(plan.sellingPlan),
          properties: {
            '_Scent Membership': 'Delivery ' + frequencyLabel() + ' · pay per order',
            '_Bottle size': state.size + ' ml',
            '_Bottle count per order': String(state.bottleCount),
            '_First delivery scent': product.title
          }
        };
      });
      try {
        var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!response.ok) {
          var errorPayload = await response.json().catch(function () { return {}; });
          throw new Error(errorPayload.description || 'The membership could not be added.');
        }
        track('scent_membership_checkout_started', { bottle_count: state.bottleCount, size_ml: state.size, frequency: state.frequency, discount_percent: planDiscount() });
        window.location.assign('/checkout');
      } catch (error) {
        state.submitting = false;
        button.disabled = false;
        button.textContent = error.message || 'Try checkout again →';
      }
    }

    builder.addEventListener('click', function (event) {
      var size = event.target.closest('[data-size]');
      var frequency = event.target.closest('[data-frequency]');
      var category = event.target.closest('[data-filter-category]');
      var scent = event.target.closest('[data-filter-scent]');
      var card = event.target.closest('[data-product-id]');
      var remove = event.target.closest('[data-remove-id]');
      var pack = event.target.closest('[data-pack]');
      if (frequency) {
        state.frequency = frequency.dataset.frequency;
        builder.querySelectorAll('[data-frequency]').forEach(function (item) {
          var active = item === frequency;
          item.classList.toggle('is-on', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        track('scent_membership_frequency_selected', { frequency: state.frequency, discount_percent: planDiscount() });
        render();
      } else if (size) {
        state.size = size.dataset.size;
        builder.querySelectorAll('[data-size]').forEach(function (item) {
          var active = item === size;
          item.classList.toggle('is-on', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        track('scent_membership_size_selected', { size_ml: state.size });
        render();
      } else if (category) {
        state.filterType = 'category'; state.filterKey = category.dataset.filterCategory; state.showAll = false; render();
      } else if (scent) {
        state.filterType = 'scent'; state.filterKey = scent.dataset.filterScent; state.showAll = false; render();
      } else if (remove) {
        removeProduct(remove.dataset.removeId);
      } else if (pack) {
        state.selected = availableProducts().filter(function (product) { return product.category === pack.dataset.pack; }).slice(0, state.bottleCount).map(function (product) { return String(product.id); });
        render();
      } else if (event.target.closest('[data-reset-filter]')) {
        state.filterType = 'category'; state.filterKey = 'all'; state.query = ''; state.showAll = false; searchInput.value = ''; render();
      } else if (event.target.closest('[data-apsm-show-all]')) {
        state.showAll = true; renderCards();
      } else if (card) {
        toggleProduct(card.dataset.productId);
      } else if (event.target.closest('[data-apsm-count-minus]')) {
        if (state.bottleCount > 1) { state.bottleCount -= 1; render(); }
      } else if (event.target.closest('[data-apsm-count-plus]')) {
        state.bottleCount += 1; render();
      } else if (event.target.closest('[data-apsm-review-cta]') || event.target.closest('[data-apsm-peek-cta]')) {
        goStep(2);
      } else if (event.target.closest('[data-apsm-back]')) {
        goStep(1);
      } else if (event.target.closest('[data-apsm-next]')) {
        if (state.step === 1) goStep(2); else submit();
      } else if (event.target.closest('[data-apsm-peek-handle]')) {
        peek.classList.toggle('is-open');
      }
    });

    var proofOriginalName = 'Golden Opulence';
    var proofSelectedName = proofOriginalName;

    function updateProofChoice(proofScent) {
      proofSelectedName = proofScent.dataset.name;
      root.querySelectorAll('[data-apsm-proof-scent]').forEach(function (item) { item.setAttribute('aria-pressed', item === proofScent ? 'true' : 'false'); });
      root.querySelector('[data-apsm-proof-summary]').textContent = proofSelectedName === proofOriginalName
        ? proofOriginalName + ' stays in your lineup'
        : proofOriginalName + ' → ' + proofSelectedName;
      var saveButton = root.querySelector('[data-apsm-proof-save]');
      saveButton.disabled = proofSelectedName === proofOriginalName;
      saveButton.textContent = saveButton.disabled ? 'Select a replacement' : 'Confirm for next month';
      root.querySelectorAll('.apsm-swap-flow span').forEach(function (step, index) {
        step.classList.toggle('is-done', index === 0 || (proofSelectedName !== proofOriginalName && index === 1));
        step.classList.toggle('is-active', index === (proofSelectedName === proofOriginalName ? 1 : 2));
      });
      root.querySelector('[data-apsm-proof-confirmation]').hidden = true;
    }

    root.addEventListener('click', function (event) {
      var proofScent = event.target.closest('[data-apsm-proof-scent]');
      var proofSave = event.target.closest('[data-apsm-proof-save]');
      var proofReset = event.target.closest('[data-apsm-proof-reset]');
      if (proofScent) {
        updateProofChoice(proofScent);
        track('scent_membership_bottle_swap_preview_used', { scent: proofScent.dataset.name });
      } else if (proofSave && !proofSave.disabled) {
        proofSave.disabled = true;
        proofSave.textContent = 'Saved for next month';
        root.querySelectorAll('.apsm-swap-flow span').forEach(function (step) { step.classList.add('is-done'); step.classList.remove('is-active'); });
        root.querySelector('[data-apsm-proof-confirmation-name]').textContent = proofSelectedName + ' is now in your next delivery.';
        root.querySelector('[data-apsm-proof-confirmation]').hidden = false;
        track('scent_membership_bottle_swap_preview_saved', { scent: proofSelectedName });
      } else if (proofReset) {
        var proofUndoneName = proofSelectedName;
        updateProofChoice(root.querySelector('[data-apsm-proof-scent][data-name="' + proofOriginalName + '"]'));
        track('scent_membership_bottle_swap_preview_undone', { scent: proofUndoneName });
      }
    });

    searchInput.addEventListener('input', function () {
      state.query = searchInput.value.trim().toLowerCase();
      state.showAll = Boolean(state.query);
      renderCards();
    });

    window.addEventListener('scroll', updateFootVisibility, { passive: true });
    window.addEventListener('resize', updateFootVisibility);

    builder.addEventListener('keydown', function (event) {
      var card = event.target.closest('[data-product-id]');
      if (card && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault(); toggleProduct(card.dataset.productId);
      }
    });

    render();
    updateFootVisibility();
  }

  document.querySelectorAll('[data-apsm]').forEach(init);
}());
